<template>
  <keep-alive >
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </keep-alive>
</template>

<script>

import { getCurrentInstance} from "vue";
export default {
  name: 'App',
  components: {

  },
  setup(){
    const metaHead=()=>{
if(window.location.protocol!='http:'){
       const cspRules = "upgrade-insecure-requests";
     // 创建meta标签
     const meta = document.createElement('meta');
     meta.httpEquiv = 'Content-Security-Policy';
     meta.content = cspRules;
     // 将meta标签添加到head中
     document.head.appendChild(meta);
}
   }
   metaHead()
    const debounce = (fn, delay) => {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      }
    }
    const { proxy } = getCurrentInstance();
    // 动态更改favicon
		const	changeFavicon=(src)=>{
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = src;
    }
    //获取平台信息
    const getPlatInfo=()=>{
      proxy.$request({
        url:"PLATCONFIG_FINDALLPLATCONFIG",
        method: "post",
        data:{},
      }).then((res)=>{
        if(res.data.code=="000"){
          let result=res.data.result;
          localStorage.setItem("platLoginInfo", JSON.stringify(result));
          result.map(item=>{
            if(proxy.tool.getDictLabel('plat_config_type',item.platConfigType)=='产业平台名称'||item.platConfigType=="0"){
              document.title = item.value
            }
            if(proxy.tool.getDictLabel('plat_config_type',item.platConfigType)=='浏览器图标'||item.platConfigType=="41"){
              changeFavicon(proxy.commenUrl+item.value);
            }
          });
        }
      }).catch((err)=>{
        console.log(err)
      });
    }
    getPlatInfo();
    //获取地图信息
    const getMapInfo=()=>{
      proxy.$request({
        url:"GET_MAP_N_FINDDEFAULT",
        method: "post",
        data:{},
      }).then((res)=>{
        if(res.data.code=="000"){
          let result=res.data.result;
          localStorage.setItem("mapCentre", result.mapCentre);
        }
      }).catch((err)=>{
        console.log(err)
      });
    }
    getMapInfo();
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* min-width: 1400px; */
  font-size: 14px;
}
body {
  margin: 0 !important;
  padding: 0 !important;
  background-color: #f7f8fa !important;
  border: none !important;
}
body,html{
  width: 100%;
  height: 100%;
}
#app{
  width: 100%;
  height: 100%;
}
</style>
